import config from '../config/config';

export default class MediaHelper {
  public static getMediaUrl(mediaId: string) {
    return `${config.api}/media/${mediaId}`;
  }
}
